import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';

import { ApiService } from '../../api/common/api.service';
import { DeviceManagerService } from '../../core/services/device-manager.service';
import { Organization } from 'src/app/api/organization/organization.model';
import { OrganizationManagerService } from 'src/app/api/organization/organization-manager.service';
import { PdfAsset } from '../../api/pdfs/pdf-asset-model';
import { ImageManagerService } from '../../api/images/image-manager.service';

@Component({
	selector: 'mycampapp-select-pdf',
	templateUrl: './select-pdf.component.html',
	styleUrls: ['./select-pdf.component.less']
})
export class SelectPDFComponent implements OnInit
{
	@HostBinding('class') private get class(): string { return this.shrinkToFit ? 'shrink-to-fit': ''; }

	@Input() shrinkToFit = false;

	_pdf?: PdfAsset;
	@Input() set pdf(value: PdfAsset | undefined) {
		this._pdf = value;
		if (value == null) return;
		this.uploadFile = undefined;
		this.uploadObjectUrl = undefined;
	}
	get pdf(): PdfAsset | undefined { return this._pdf; }

	_pdfUrl?: string; // As an alternative to pdf: PdfAsset
	@Input() set pdfUrl(value: string | undefined) {
		this._pdfUrl = value;
		if (value == null) return;
		this.uploadFile = undefined;
		this.uploadObjectUrl = undefined;
	}
	get pdfUrl(): string | undefined { return this._pdfUrl; }
	@Input() disabled = false;

	filename?: string;
	pdfRemoved = false;
	organization!: Organization;
	selectedUrl?: string;
	selectExistingPdfVisible = false;
	uploadObjectUrl: any;
	uploadFile?: File;

	@Output() changed = new EventEmitter();


	constructor(public deviceManager: DeviceManagerService,
				private orgManager: OrganizationManagerService,
	            private messageService: MessageService) { }

	ngOnInit(): void
	{
		this.orgManager.currentOrganization.subscribe(org => this.organization = org);
	}

	clear(): void
	{
		this._pdf = undefined;
		this._pdfUrl = undefined;
		this.uploadFile = undefined;
		this.uploadObjectUrl = undefined;
		this.filename = undefined;
		this.pdfRemoved = false;
		this.selectedUrl = undefined;
	}

	get hasFile(): boolean
	{
		return !this.pdfRemoved && this.pdf != undefined || this.pdfUrl != undefined || this.selectedUrl !== undefined || this.uploadFile != undefined;
	}

	get previewSize(): string { return this.deviceManager.isMobile ? '100px' : '200px'; }

	get selectedFileOrUrl(): File | string | undefined { return this.uploadFile || this.selectedUrl; }

	get pdfSize(): number { return this.deviceManager.isMobile ? 150 : 200; }

	onFilesSelected(event: any)
	{
		if (event === undefined) return;
		this.pdfRemoved = false;
		this.uploadFile = <File>event.files[0];
		this.selectedUrl = undefined;
		if (this.uploadFile.size > ImageManagerService.MAX_PDF_FILE_SIZE)
		{
			this.displayError(`PDF files must be less than ${ImageManagerService.MAX_PDF_FILE_SIZE_MB} MB in size.`);
			return;
		}

		if (!ApiService.isValidUploadFilename(this.uploadFile.name))
		{
			this.displayError('The filename cannot contain special characters. Please use only letters, numbers, underscores, and dashes.');
			return;
		}

		this.uploadObjectUrl = URL.createObjectURL(this.uploadFile);
		this.filename = this.uploadFile.name.substring(this.uploadFile.name.lastIndexOf('/') + 1);
		this.changed.emit();
	}

	onChooseExistingPDF(): void
	{
		this.selectExistingPdfVisible = true;
	}

	onPdfSelected(pdf?: PdfAsset)
	{
		this.selectExistingPdfVisible = false;
		if (pdf === undefined) return;

		this.pdfRemoved = false;
		this.selectedUrl = pdf.Url;
		this.uploadFile = undefined;
		this.uploadObjectUrl = undefined;
		this.filename = undefined;
		this.changed.emit();
	}

	onRemovePdf(): void
	{
		this.uploadFile = undefined;
		this.selectedUrl = undefined;
		this.filename = undefined;
		this.pdfRemoved = this.pdf != undefined || this.pdfUrl != undefined;
		this.changed.emit();
	}

	private displayError(text: string): void
	{
		this.messageService.add({ severity: 'error', summary: 'File error', detail: text });
		this.uploadFile = undefined;
		this.uploadObjectUrl = undefined;
	}
}
